const config = {
    showAuthors: true
};

export default config;